"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("firebase/firestore");
/**
 * @param firestore
 * @param uid
 * @param  {string} subscriptionUid uid del suscriptor
 * @returns Suscripción
 */
async function getSubscription(firestore, uid, subscriptionUid) {
    let subscription;
    const path = `user/${uid}/subscriptions/`;
    try {
        const subRef = (0, firestore_1.doc)(firestore, path, subscriptionUid);
        subscription = await (0, firestore_1.getDoc)(subRef);
    }
    catch (err) {
        throw new Error(`db error ${err}`);
    }
    if (subscription.exists()) {
        return subscription.data();
    }
    else {
        throw new Error("error: patient don't exist.");
    }
}
exports.default = getSubscription;
